import React, { useState, useEffect } from "react";
import "./HomeContent.css";
import { Link } from "react-router-dom";
import OfferingsData from "../data/OfferingsData.json";
import TestimonialsContent from "./TestimonialsContent";
import AOS from "aos";
import "aos/dist/aos.css";

function HomeContent() {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  return (
    <>
      <div className="main-banner">
        <img
          src="images/Home/bannerind.png"
          alt="banner"
          className="banner-img"
        />
        <div className="main-heading-box"></div>
      </div>
      {/* first sec */}
      <div className="about-sec" id="about-us">
        <div className="about-wrap">
          <h2>About Us</h2>
          <div className="about-row row1" data-aos="zoom-in-up">
            <div className="about-box-img">
              <img
                src="images/Home/about-tile.png"
                alt="about"
                className="about-tile"
              />
            </div>
          </div>
          <div className="about-row row2" data-aos="zoom-in-up">
            <div className="about-box">
              <p>
                At Advanced Technology centers in India, our commitment is to
                cultivate an empowering environment for all our employees, with
                a special <strong>emphasis on women</strong> at every career
                level.
              </p>
              <p>
                We aim to facilitate their individual growth and enable them to
                define success on their terms. Our primary focus is on
                maintaining a continuous and highly{" "}
                <strong>flexible learning atmosphere,</strong> ensuring that our
                female professionals can develop profound technology expertise
                and stay at the forefront of <strong>industry trends.</strong>{" "}
                Through dedicated workplace policies and programs, we support
                the personal and <strong>professional aspirations</strong> of
                our women, aiming to foster transformative technology leaders.
              </p>
              <p>
                These leaders are not only equipped to navigate the
                uncertainties of today but also possess a{" "}
                <strong>strategic mindset</strong> and the passion to reimagine
                the future for Accenture, our clients, and the communities we
                serve.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* second sec */}
      <div className="offerings-sec" id="offerings">
        <div className="offerings-wrap">
          <h2>Our Offerings</h2>
          {/* <p>
            At our program, we're committed to fostering an inclusive
            environment where excel in the rapidly evolving landscape of
            technology.
          </p> */}
          <p>
            Elevate your tech prowess through our dedicated learning portal for
            women. From skill-building modules to in-depth courses, we provide a
            one-stop destination to fuel your growth and success in the{" "}
            <strong>dynamic field of technology.</strong>
          </p>
          {OfferingsData.map((item) => {
            return (
              <div
                key={item.id}
                className="offerings-row"
                data-aos="zoom-in-up"
              >
                <div className="offerings-box">
                  <div className="offerings-img-holder">
                    <a href={item.offeringslink} target="_blank">
                      <img
                        src={item.offeringsimg}
                        alt="offerings"
                        className="offerings-img"
                      />
                    </a>
                  </div>
                  <div className="offerings-text-holder">
                    <h3>{item.offeringscourse}</h3>
                    <p>{item.offeringstext}</p>
                    <p className="explore-link">
                      <a href={item.offeringslink} target="_blank">
                        Explore More{" "}
                        <span>
                          <img
                            src="images/Home/explore-arrow.png"
                            alt="explore"
                            className="explore-arrow"
                          />
                        </span>
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {/* third section */}
      <div className="testimonial-sec">
        <div className="testimonial-wrap">
          <h2>Testimonials</h2>
          <TestimonialsContent />
        </div>
      </div>
    </>
  );
}

export default HomeContent;
